import { registerMockAPI } from '~/mocks/mockApis';

import {
  type TypeCreateGuestAccountsPhoneVerificationRequest,
  type TypeCreateGuestAccountsPhoneVerificationResponse,
} from '~/api/guestAccounts/types';
import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/**
 * @description 비회원 인증번호 발송 요청 api에 사용되는 커스텀 훅
 */
export const useVerifyGuestRequestSms = () => {
  return useDedupeMutation<
    TypeCreateGuestAccountsPhoneVerificationRequest,
    TypeCreateGuestAccountsPhoneVerificationResponse
  >({
    mutationFn: (params: TypeCreateGuestAccountsPhoneVerificationRequest) => {
      const endpoint = '/guest-accounts/phone-verification';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });
};

registerMockAPI<TypeCreateGuestAccountsPhoneVerificationResponse>({
  method: 'post',
  endpoint: '/guest-accounts/phone-verification',
  label: '근무 지원 정보/비회원 인증번호 발송 요청',
  scenarios: [
    {
      name: '성공',
      response: {
        code: '0000',
        message: '정상',
        data: {
          isMember: false,
        },
      },
    },
    {
      name: '가입 회원인 경우',
      response: {
        code: '0000',
        message: '정상',
        data: {
          isMember: true,
        },
      },
    },
  ],
});
